import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { format } from "date-fns";
import { environment } from "@estatex/environments";
import { Booking, CreateBookingRequest } from "@estatex/types";
import { Observable } from "rxjs";
import { Store } from "@ngrx/store";
@Injectable({
    providedIn: "root",
})
export class BookingService {
    constructor(private httpClient: HttpClient, private ngrxStore: Store) {}

    private formatDate(date: Date): string {
        return format(date, "ddMMyyyy");
    }

    /**
     * Creates Booking
     * @param bookingRequest - Booking to create
     * @returns
     */
    createBooking(bookingRequest: CreateBookingRequest): Observable<any> {
        return this.httpClient.post(`${environment.API_URL}/api/booking`, bookingRequest);
    }

    /**
     * Gets Booking Details
     * @param bookingNumber - Booking number to view
     * @returns
     */
    getBooking(bookingNumber: string): Observable<Booking> {
        return this.httpClient.get<Booking>(`${environment.API_URL}/api/booking/${bookingNumber}`);
    }
}
